import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import type {BusinessCaseOnlineOfferResponseBody} from '../api/types/onlineOfferTypes';

type HeroPhotoSource = Partial<
  Pick<BusinessCaseOnlineOfferResponseBody, 'saleVehiclePhotos' | 'illustrativePhoto'>
>;

/**
 * The photos the hero shows, on screen and in print: the car's own, else the live catalogue photo
 * of its configuration, which is illustrative and must be captioned as such.
 */
export const getHeroPhotos = (offer: HeroPhotoSource) =>
  isNotNilOrEmpty(offer.saleVehiclePhotos) || isNil(offer.illustrativePhoto)
    ? {photos: offer.saleVehiclePhotos ?? [], isIllustrative: false}
    : {
        photos: [{id: offer.illustrativePhoto.fileId, url: offer.illustrativePhoto.url}],
        isIllustrative: true,
      };
